import React, { useContext, useRef } from 'react';
import {
    Box,
    Typography,
    Paper,
    Grid,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Avatar,
    IconButton,
    Card,
    CardContent
} from '@mui/material';
import logotcl from "../../logo/logotcl.png";
import payslipLogo from "../../logo/paySlip.png";
import logoALLIED from "../../logo/logoALLIED.jpg";
import logo from "../../logo/logo.svg";
import { Close } from '@mui/icons-material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { AuthContext } from '../../helper/context/auth/authContext';
import { getValidLogo, convertToMoneyWords } from '../../helper/function-helper';
import dayjs from 'dayjs';

const PaySlipBulkPdf = ({ data=[], month, handleClose, formData }) => {
    const payslipRef = useRef();
    const { user } = useContext(AuthContext);
    const payslipLogo = getValidLogo(user?.[0]?.PayslipLogo, logo);
    const emp = data[0] || {};
    const earnings = data?.filter(item => item.Classification === 'Earning');
    const deductions = data?.filter(item => item.Classification === 'Deduction');
    const information = data?.filter(item => item.Classification === 'Information');
    const summaryItems = data?.filter(item => item.Classification === 'Summary');
    const grossEarningsItem = summaryItems?.find(i => i.PayElementDesc === 'Gross Amount');
    const netSalaryItem = summaryItems?.find(i => i.PayElementDesc === 'Net Salary');
    const totalDeductionItem = summaryItems?.find(i => i.PayElementDesc === 'Total Deduction');
    const companyData = data?.filter(item => item.empcode === emp?.EmployeeNumber);

    const toCurrency = amount => {
        const num = parseFloat(amount);
        return isNaN(num)
            ? '-'
            : `${emp.CurrencyCode} ${num.toLocaleString(undefined, { minimumFractionDigits: 2 })}`;
    };

    const dateofBirthandDateofJoiningFormatChange = (dateString) => {
         if (!dateString) return "N/A";
         const parsed = dayjs(
             dateString,
             ["DD-MMM-YYYY", "DD-MMM-YYYY", "DD/MM/YYYY", "MM/DD/YYYY"],
             true
         );
         const formatted = parsed.isValid()
             ? parsed.format("DD-MMM-YYYY")
             : "N/A";
         return formatted;
     };


    return (
        <>
            {/* <Paper elevation={3} sx={{ p: 2, maxWidth: 800, margin: 'auto', fontFamily: 'Arial' }}>
                <Grid container alignItems="center" justifyContent="space-between" mb={3}>
                    <Grid item>
                        <Typography variant="h5" fontWeight="bold" sx={{ textTransform: 'uppercase' }}>
                            {companyData[0]?.CompanyName}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            {companyData[0]?.CompanyAddress}
                        </Typography>
                    </Grid>
                    <Grid item sx={{ textAlign: 'right' }}>
                            <img
                                src={payslipLogo}
                                alt="Logo"
                                style={{ width: "80px", height: "auto" }}
                            />
                    </Grid>
                </Grid>
                <Paper variant="outlined" sx={{ mb: 3 }}>
                    <Box bgcolor="#f5f5f5" p={1.5} borderBottom="1px solid #e0e0e0">
                        <Typography fontWeight="bold">
                            EMPLOYEE SUMMARY - <span style={{ color: '#ed6c02' }}>{emp?.FullName} - {month}</span>
                        </Typography>
                    </Box>
                    <Box p={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                {[
                                    ['Employee Name', emp?.FullName],
                                    ['Employee ID', emp?.EmployeeNumber],
                                    ['DOJ', formatDate(emp?.DateOfJoining)],
                                    ['DOB', formatDate(emp?.DateOfBirth)],
                                    ['Designation', emp?.Designation],
                                    ['Department', emp?.Department],
                                    ['Location', emp?.Location],
                                    ['Emirates ID', emp?.EmiratesID],
                                    ['Nationality', emp?.NationalityName],
                                    ['Passport No', emp?.PassportNo],
                                    ['Visa No', emp?.VisaNo],

                                ].map(([label, val], i) => (
                                    <Box key={i} display="flex" alignItems="center" >
                                        <Typography variant="body2" sx={{ color: '#ed6c02', minWidth: '130px', fontWeight: 500, fontSize: "12px" }}>
                                            {label}
                                        </Typography>
                                        <Typography variant="body2" sx={{ ml: 1, fontSize: "12px" }}>
                                            :&nbsp;{val || '-'}
                                        </Typography>
                                    </Box>
                                ))}
                            </Grid>

                            <Grid item xs={12} md={6}>
                                {[
                                    ['Bank Name', emp?.BankName],
                                    ['IBAN', emp?.AccountNo],
                                    // ...information.map(info => [info.PayElementDesc, info.Amount]),
                                    ['Earned Leaves', data?.find(item => item?.PayElementDesc === "Earned Leaves")?.Amount || "0"],
                                    ['Leave Availed', data?.find(item => item?.PayElementDesc === "Leave Availed")?.Amount || "0"],
                                    ['Leave Balance', data?.find(item => item?.PayElementDesc === "Leave Balance")?.Amount || "0"],
                                ].map(([label, val], i) => (
                                    <Box key={i} display="flex" alignItems="center" >
                                        <Typography variant="body2" sx={{ color: '#ed6c02', minWidth: '130px', fontWeight: 500, fontSize: "12px" }}>
                                            {label}
                                        </Typography>
                                        <Typography variant="body2" sx={{ ml: 1, fontSize: "12px" }}>
                                            :&nbsp;{val}
                                        </Typography>
                                    </Box>
                                ))}

                                <Card sx={{ backgroundColor: '#f0fff4', borderRadius: 2, maxWidth: 400, mx: 'auto', mt: 1.5 }}>
                                    <CardContent sx={{ paddingBottom: "20px" }}>
                                        <Typography variant="h5" align="center" fontWeight="bold" gutterBottom>
                                            {toCurrency(netSalaryItem?.Amount)}
                                        </Typography>
                                        <Typography variant="subtitle2" align="center" color="text.secondary" gutterBottom>
                                            Total Net Pay
                                        </Typography>
                                        <Grid container justifyContent="space-between" mt={2}>
                                            <Typography variant="body2">
                                                <strong>Paid Days:</strong> {emp?.PaidDays}
                                            </Typography>
                                            <Typography variant="body2">
                                                <strong>LOP Days:</strong> {emp?.LOPDays}
                                            </Typography>
                                        </Grid>
                                    </CardContent>
                                </Card>


                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
                <Grid container spacing={2} mb={1}>
                    <Grid item xs={12} md={6}>
                        <Paper variant="outlined">
                            <Box bgcolor="#f5f5f5" p={1} borderBottom="1px solid #e0e0e0">
                                <Typography fontWeight="bold">EARNINGS</Typography>
                            </Box>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{fontWeight:"900",fontSize:17}}>Item</TableCell>
                                        <TableCell align="right" sx={{fontWeight:"900",fontSize:17}}>Amount</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {earnings.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell sx={{ fontSize: "12px" }}>{row.PayElementDesc}</TableCell>
                                            <TableCell sx={{ fontSize: "12px" }} align="right">{toCurrency(row.Amount)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper variant="outlined">
                            <Box bgcolor="#f5f5f5" p={1} borderBottom="1px solid #e0e0e0">
                                <Typography fontWeight="bold">DEDUCTIONS</Typography>
                            </Box>
                            {deductions.length > 0 ? (
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Item</TableCell>
                                            <TableCell align="right">Amount</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {deductions.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{row.PayElementDesc}</TableCell>
                                                <TableCell align="right">{toCurrency(row.Amount)}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            ) : (
                                <Box p={2} textAlign="center">
                                    <Typography variant="body2" color="#ed6c02" fontStyle="italic">
                                        No deductions applied
                                    </Typography>
                                </Box>
                            )}
                        </Paper>
                    </Grid>
                </Grid>
                <Paper variant="outlined" sx={{ mb: 2 }}>
                    <Box p={2}>
                        <Box display="flex" justifyContent="space-between" mb={1}>
                            <Typography variant="body2">Gross Earnings:</Typography>
                            <Typography variant="body2" fontWeight="bold">{toCurrency(grossEarningsItem?.Amount)}</Typography>
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={1}>
                            <Typography variant="body2">Additions:</Typography>
                            <Typography variant="body2" fontWeight="bold">{companyData[0]?.Additions === "0" ? '—' : toCurrency(companyData[0]?.Additions)}</Typography>
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={1}>
                            <Typography variant="body2">Total Deduction:</Typography>
                            <Typography variant="body2" fontWeight="bold">{toCurrency(totalDeductionItem?.Amount)}</Typography>
                        </Box>
                        <Divider sx={{ my: 1 }} />
                        <Box display="flex" justifyContent="space-between" alignItems="center" py={1}>
                            <Typography variant="body1" fontWeight="bold">Net Payable:</Typography>
                            <Paper elevation={0} sx={{ bgcolor: '#f0fdf4', px: 2, py: 1, borderRadius: 1 }}>
                                <Typography variant="body1" fontWeight="bold">{toCurrency(netSalaryItem?.Amount)}</Typography>
                            </Paper>
                        </Box>
                        <Box textAlign="right" mt={1}>
                            <Typography variant="caption" color="text.secondary">
                                Amount in Words: <span style={{ color: '#ed6c02' }}>{convertToMoneyWords(netSalaryItem?.Amount, emp?.CurrencyCode)}</span>
                            </Typography>
                        </Box>
                    </Box>
                </Paper>
                <Typography variant="caption" color="text.secondary" display="flex" justifyContent="center" textAlign="center" fontStyle="italic">
                    --- This is a system generated payslip and does not require signature. ---
                </Typography>
            </Paper> */}
            <Paper
                elevation={3}
                sx={{
                    p: 2,
                    maxWidth: 800,
                    margin: 'auto',
                    fontFamily: 'Arial',
                    lineHeight: 1.2,
                    // force smaller font for all descendant elements inside the payslip
                    '& *': {
                        fontSize: '12px !important'
                    },
                    // tighten table rows and cells for compact layout
                    '& .MuiTableCell-root': {
                        padding: '6px 8px',
                        fontSize: '11px !important',
                        lineHeight: 1.1,
                    },
                    '& .MuiTableRow-root': {
                        // allow rows to shrink to content and remove extra min-height
                        '& > .MuiTableCell-root': {
                            paddingTop: '4px',
                            paddingBottom: '4px',
                        }
                    },
                    // remove bottom border on final row cells
                    '& .MuiTableBody-root .MuiTableRow-root:last-child > .MuiTableCell-root': {
                        paddingBottom: '4px !important',
                        borderBottom: 'none !important'
                    }
                }}
                ref={payslipRef}
            >
                <Grid container direction="column" spacing={1} mb={3}>
                    <Grid item>
                        <Box sx={{ borderBottom: "1px solid black" }} />
                    </Grid>
                    <Grid item>
                        <Grid
                            container
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{ py: 0 }}
                        >
                            <Grid item>
                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item>
                                        {/* <img
                                            src={payslipLogo}
                                            alt="Logo"
                                            style={{ width: "40px", height: "auto" }}
                                        /> */}
                                        <img
                                            src={companyData[0]?.CompanyName === 'Alliad Somalia' ? 'https://clubitsstoragepoc.blob.core.windows.net/upload/logo-1769491406637.png' : "https://clubitsstoragepoc.blob.core.windows.net/upload/logo-1764238971705.png"}
                                            alt="Logo"
                                            style={{ width: "120px", height: "auto" }}
                                        />
                                    </Grid>
                                    <Grid item>
                                        {/* <Typography
                                            variant="h5"
                                            fontWeight="bold"
                                            sx={{ textTransform: "uppercase" }}
                                        >
                                            {companyData[0]?.CompanyName}
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary">
                                            {companyData[0]?.CompanyAddress}
                                        </Typography> */}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item>
                                {emp?.EmployeeType === 'Consultant' ?
                                    <Typography variant="body2" fontWeight="bold" color="black">
                                        MONTHLY CONSULTANCY FEE STATEMENT
                                    </Typography>
                                    :
                                    <Typography variant="body2" fontWeight="bold" color="black">
                                        MONTHLY PAY SLIP
                                    </Typography>
                                }
                                <Typography variant="body2" color="black" align="right">
                                    {month} 
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ borderBottom: "1px solid black" }} />
                    </Grid>
                </Grid>
                {/* Employee Summary */}
                <Paper variant="outlined" sx={{ mb: 3 }}>
                    {/* <Box p={1.5} borderBottom="1px solid #e0e0e0" >
                        <Typography fontWeight="bold">
                            EMPLOYEE SUMMARY - <span >{emp?.FullName} - {month?.ProcessPeriodDescription}</span>
                        </Typography>
                    </Box> */}
                    <Box p={2}>
                        <Grid container spacing={2}>
                            {/* Left column */}
                            <Grid item xs={12} md={6}>
                                {(emp?.EmployeeType === 'Consultant' ? [
                                    ['Consultant Name', emp?.FullName],
                                    ['Consultant Number', emp?.EmployeeNumber],
                                    ['Contract Start Date', dateofBirthandDateofJoiningFormatChange(emp?.DateOfJoining)],
                                    ["Contract End Date", emp?.DateOfLeaving],
                                    // ['DOB', dateofBirthandDateofJoiningFormatChange(emp?.DateOfBirth)],
                                    ['Scope', emp?.Designation],
                                    ['No. of Worked Days', data?.find(item => item?.PayElementDesc === "Days Worked")?.Amount || data?.find(item => item?.PayElementDesc === "Working Days")?.Amount || "0"],
                                    ['No. of Worked Hours', emp?.HoursWorked]
                                ] : [
                                    ['Employee Name', emp?.FullName],
                                    ['Employee ID', emp?.EmployeeNumber],
                                    ['DOJ', dateofBirthandDateofJoiningFormatChange(emp?.DateOfJoining)],
                                    ['DOB', dateofBirthandDateofJoiningFormatChange(emp?.DateOfBirth)],
                                    ['Designation', emp?.Designation],
                                ]).map(([label, val], i) => (
                                    <Box
                                        key={i}
                                        sx={{
                                            display: 'grid',
                                            gridTemplateColumns: '150px auto 1fr', // label | colon | value
                                            columnGap: 1,
                                            mb: 1,
                                            alignItems: 'start'
                                        }}
                                    >
                                        {/* Label */}
                                        <Typography
                                            variant="body2"
                                            sx={{ fontWeight: 500, whiteSpace: 'nowrap' }}
                                        >
                                            {label}
                                        </Typography>

                                        {/* Colon */}
                                        <Typography variant="body2">:</Typography>

                                        {/* Value */}
                                        <Typography
                                            variant="body2"
                                            sx={{ fontSize: '0.8rem', wordBreak: 'break-word' }}
                                        >
                                            {val || '-'}
                                        </Typography>
                                    </Box>
                                ))}
                            </Grid>

                            {/* Right column */}
                            <Grid item xs={12} md={6}>
                                <Box mb={2}>
                                {(emp?.EmployeeType === 'Consultant'
                                ? [
                                ['Bank', emp?.BankName],
                                ['IBAN', emp?.AccountNo],
                                ['Paid Time-Off Balance', data?.find(i => i?.PayElementDesc === "Leave Balance")?.Amount || "0"],
                                ['Earned Paid Time-Off', data?.find(i => i?.PayElementDesc === "Leave Earned")?.Amount || "0"],
                                ['Paid Time-Off Availed', data?.find(i => i?.PayElementDesc === "Leave Availed")?.Amount || "0"],
                                ['No. of Calendar Days',
                                        data?.find(i => i?.PayElementDesc === "No. of Calendar Days")?.Amount || "0"
                                    ],
                                ['Rate', emp?.Rate],
                                ]:[['Bank', emp?.BankName],
                                   ['IBAN', emp?.AccountNo],]).map(([label, val], i) => (
                                <Box
                                    key={i}
                                    sx={{
                                    display: 'grid',
                                    gridTemplateColumns: emp?.EmployeeType !== 'Consultant' ? '100px auto 1fr' : '150px auto 1fr',
                                    columnGap: 1,
                                    mb: 1,
                                    }}
                                >
                                    <Typography sx={{ fontWeight: 500 }}>{label}</Typography>
                                    <Typography>:</Typography>
                                    <Typography>{val}</Typography>
                                </Box>
                                ))}
                            </Box>

                            <Box
                                sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gap: 2,
                                }}
                            >
                                {(emp?.EmployeeType === 'Consultant'
                                ? []
                                : [
                                    ['Opening Leave Balance', data?.find(i => i?.PayElementDesc === "Opening Leave Balance")?.Amount || "0"],
                                    ['Earned Leave', data?.find(i => i?.PayElementDesc === "Leave Earned")?.Amount || "0"],
                                    ['Leave Balance', data?.find(i => i?.PayElementDesc === "Leave Balance")?.Amount || "0"],
                                    ['Leave Availed', data?.find(i => i?.PayElementDesc === "Leave Availed")?.Amount || "0"],
                                    ]
                                ).map(([label, val], i) => (
                                <Box key={i} display="flex"
                                    sx={{
                                    display: 'grid',
                                    gridTemplateColumns: '100px auto 1fr',
                                    columnGap: 1,
                                    //   mb: 0.5,
                                    }}>
                                    <Typography sx={{ fontWeight: 500 }}>{label}</Typography>
                                    <Typography>:</Typography>
                                    <Typography>{val}</Typography>
                                </Box>
                                ))}
                                </Box>

                            </Grid>
                        </Grid>

                    </Box>
                </Paper>
                <Grid container spacing={2} mb={3}>
                    <Grid item xs={12} md={6}>
                        <Paper variant="outlined">
                            <Box p={1.5} borderBottom="1px solid #e0e0e0">
                                {emp?.EmployeeType === 'Consultant' ?
                                    <Typography fontWeight="bold">CONSULTANCY FEES </Typography> :
                                    <Typography fontWeight="bold">EARNINGS</Typography>
                                }
                            </Box>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: "900", fontSize: 17 }}>Item</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: "900", fontSize: 17 }}>Amount</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {earnings.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell>
                                                {(row.PayElementDesc === 'Basic' && emp?.EmployeeType === 'Consultant') ? 'Earnings' : (row.PayElementDesc === 'Housing Allowance' && emp?.EmployeeType === 'Consultant') ? 'Housing Support' : row.PayElementDesc}
                                            </TableCell>
                                            <TableCell align="right">{toCurrency(row.Amount)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper variant="outlined">
                            <Box p={1.5} borderBottom="1px solid #e0e0e0">
                                <Typography fontWeight="bold">DEDUCTIONS</Typography>
                            </Box>
                            {deductions.length > 0 ? (
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Item</TableCell>
                                            <TableCell align="right">Amount</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {deductions.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{row.PayElementDesc}</TableCell>
                                                <TableCell align="right">{toCurrency(row.Amount)}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            ) : (
                                <Box p={2} textAlign="center">
                                    <Typography variant="body2" color="black" fontStyle="italic">
                                        No deductions applied
                                    </Typography>
                                </Box>
                            )}
                        </Paper>
                    </Grid>
                </Grid>
                <Paper variant="outlined" sx={{ mb: 2 }}>
                    <Box p={2}>
                        <Box display="flex" justifyContent="space-between" mb={1}>
                            <Typography variant="body2">Gross Earnings:</Typography>
                            <Typography variant="body2" fontWeight="bold">{toCurrency(grossEarningsItem?.Amount)}</Typography>
                        </Box>
                        {/* <Box display="flex" justifyContent="space-between" mb={1}>
                            <Typography variant="body2">Additions:</Typography>
                            <Typography variant="body2" fontWeight="bold">{companyData[0]?.Additions === "0" ? '—' : toCurrency(companyData[0]?.Additions)}</Typography>
                        </Box> */}
                        <Box display="flex" justifyContent="space-between" mb={1}>
                            <Typography variant="body2">Total Deduction:</Typography>
                            <Typography variant="body2" fontWeight="bold">{totalDeductionItem?.Amount === "0" ? '—' : toCurrency(totalDeductionItem?.Amount)}</Typography>
                        </Box>
                        <Divider sx={{ my: 1 }} />
                        <Box display="flex" justifyContent="space-between" alignItems="center" py={1}>
                            <Typography variant="body1" fontWeight="bold">Net Payable:</Typography>
                            <Paper elevation={0} sx={{ px: 2, py: 1, borderRadius: 1 }}>
                                <Typography variant="body1" fontWeight="bold">{toCurrency(netSalaryItem?.Amount)}</Typography>
                            </Paper>
                        </Box>
                        <Box textAlign="right" mt={1}>
                            <Typography variant="caption" color="text.secondary">
                                Amount in Words: <span style={{ color: 'black' }}>{<span>{convertToMoneyWords(netSalaryItem?.Amount, emp.CurrencyCode)}</span>}</span>
                            </Typography>
                        </Box>
                    </Box>
                </Paper>
                {emp?.EmployeeType === 'Consultant' ?
                    <Typography variant="caption" color="text.secondary" display="flex" justifyContent="center" textAlign="center" fontStyle="italic">

                        --- This statement is issued for consultancy services rendered and does not constitute an employee payslip. ---
                    </Typography>
                    :
                    <Typography variant="caption" color="text.secondary" display="flex" justifyContent="center" textAlign="center" fontStyle="italic">
                        --- This is a system generated payslip and does not require signature. ---
                    </Typography>
                }
            </Paper>
        </>

    );
};

export default PaySlipBulkPdf;
